import { render } from "./AllUserPortalSettings.vue?vue&type=template&id=565b8544&scoped=true"
import script from "./AllUserPortalSettings.vue?vue&type=script&lang=js"
export * from "./AllUserPortalSettings.vue?vue&type=script&lang=js"

import "./AllUserPortalSettings.vue?vue&type=style&index=0&id=565b8544&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-565b8544"]])

export default __exports__